var _g, _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5, _g2, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_20020_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45738 11.257C8.85631 9.01019 11.7638 8.24275 14.0894 9.50655L16.9695 11.0717L12.6635 18.1527L11.2492 14.6114L6.93168 22.1308C6.22905 23.3573 4.65904 23.7723 3.44218 23.0531L3.32567 22.9842C2.11174 22.2668 1.7166 20.6966 2.44633 19.49L6.06663 13.5038L6.06102 13.4998L6.34184 13.0488L6.9246 12.0852C7.09585 11.8022 7.263 11.5295 7.45738 11.257Z",
    fill: "url(#paint0_linear_20020_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45738 11.257C8.85631 9.01019 11.7638 8.24275 14.0894 9.50655L16.9695 11.0717L12.6635 18.1527L11.2492 14.6114L6.93168 22.1308C6.22905 23.3573 4.65904 23.7723 3.44218 23.0531L3.32567 22.9842C2.11174 22.2668 1.7166 20.6966 2.44633 19.49L6.06663 13.5038L6.06102 13.4998L6.34184 13.0488L6.9246 12.0852C7.09585 11.8022 7.263 11.5295 7.45738 11.257Z",
    fill: "url(#paint1_radial_20020_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45738 11.257C8.85631 9.01019 11.7638 8.24275 14.0894 9.50655L16.9695 11.0717L12.6635 18.1527L11.2492 14.6114L6.93168 22.1308C6.22905 23.3573 4.65904 23.7723 3.44218 23.0531L3.32567 22.9842C2.11174 22.2668 1.7166 20.6966 2.44633 19.49L6.06663 13.5038L6.06102 13.4998L6.34184 13.0488L6.9246 12.0852C7.09585 11.8022 7.263 11.5295 7.45738 11.257Z",
    fill: "url(#paint2_linear_20020_6365)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1729 27.1165L14.5019 25.3918L15.8541 23.4062H29.8839V27.9849C29.8839 29.0894 28.9885 29.9849 27.8839 29.9849H19.3667C17.511 29.9849 15.8457 28.8458 15.1729 27.1165Z",
    fill: "url(#paint3_linear_20020_6365)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1729 27.1165L14.5019 25.3918L15.8541 23.4062H29.8839V27.9849C29.8839 29.0894 28.9885 29.9849 27.8839 29.9849H19.3667C17.511 29.9849 15.8457 28.8458 15.1729 27.1165Z",
    fill: "url(#paint4_linear_20020_6365)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1729 27.1165L14.5019 25.3918L15.8541 23.4062H29.8839V27.9849C29.8839 29.0894 28.9885 29.9849 27.8839 29.9849H19.3667C17.511 29.9849 15.8457 28.8458 15.1729 27.1165Z",
    fill: "url(#paint5_radial_20020_6365)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.93274,
    y: 22.8918,
    width: 4.83229,
    height: 6.98529,
    rx: 2.41614,
    fill: "url(#paint6_radial_20020_6365)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.93274,
    y: 22.8918,
    width: 4.83229,
    height: 6.98529,
    rx: 2.41614,
    fill: "url(#paint7_radial_20020_6365)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.93274,
    y: 22.8918,
    width: 4.83229,
    height: 6.98529,
    rx: 2.41614,
    fill: "url(#paint8_linear_20020_6365)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1402 2.26631C18.2778 2.02645 18.5841 1.94392 18.8237 2.08212L21.7874 3.79185C22.0261 3.92953 22.1084 4.23435 21.9714 4.47344L8.42945 28.1185C8.38019 28.2045 8.30649 28.2739 8.21771 28.3179L5.0419 29.8928C4.88047 29.9729 4.74446 29.8934 4.73566 29.7135L4.50957 26.1719C4.5049 26.0764 4.52772 25.9815 4.57533 25.8986L18.1402 2.26631Z",
    fill: "url(#paint9_radial_20020_6365)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1402 2.26631C18.2778 2.02645 18.5841 1.94392 18.8237 2.08212L21.7874 3.79185C22.0261 3.92953 22.1084 4.23435 21.9714 4.47344L8.42945 28.1185C8.38019 28.2045 8.30649 28.2739 8.21771 28.3179L5.0419 29.8928C4.88047 29.9729 4.74446 29.8934 4.73566 29.7135L4.50957 26.1719C4.5049 26.0764 4.52772 25.9815 4.57533 25.8986L18.1402 2.26631Z",
    fill: "url(#paint10_radial_20020_6365)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_20020_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2412 8.38184L8.18994 24.319",
    stroke: "url(#paint11_linear_20020_6365)",
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_20020_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93275 22.0306C8.68202 22.905 8.27955 24.6642 9.09547 25.9539C9.93141 27.2752 11.7691 27.6629 13.1005 26.8432L16.6299 24.6703C17.0642 24.4029 17.6334 24.5436 17.8931 24.9826C19.2527 27.2807 21.8251 28.5776 24.4811 28.3042L28.3131 27.9097C29.2055 27.8179 29.8839 27.0661 29.8839 26.1689V19.0386C29.8839 17.907 29.1912 16.89 28.1467 16.4544C25.9197 15.5256 21.8649 13.7653 17.8516 11.6689L13.1107 19.9492L9.93275 22.0306Z",
    fill: "url(#paint12_linear_20020_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93275 22.0306C8.68202 22.905 8.27955 24.6642 9.09547 25.9539C9.93141 27.2752 11.7691 27.6629 13.1005 26.8432L16.6299 24.6703C17.0642 24.4029 17.6334 24.5436 17.8931 24.9826C19.2527 27.2807 21.8251 28.5776 24.4811 28.3042L28.3131 27.9097C29.2055 27.8179 29.8839 27.0661 29.8839 26.1689V19.0386C29.8839 17.907 29.1912 16.89 28.1467 16.4544C25.9197 15.5256 21.8649 13.7653 17.8516 11.6689L13.1107 19.9492L9.93275 22.0306Z",
    fill: "url(#paint13_radial_20020_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93275 22.0306C8.68202 22.905 8.27955 24.6642 9.09547 25.9539C9.93141 27.2752 11.7691 27.6629 13.1005 26.8432L16.6299 24.6703C17.0642 24.4029 17.6334 24.5436 17.8931 24.9826C19.2527 27.2807 21.8251 28.5776 24.4811 28.3042L28.3131 27.9097C29.2055 27.8179 29.8839 27.0661 29.8839 26.1689V19.0386C29.8839 17.907 29.1912 16.89 28.1467 16.4544C25.9197 15.5256 21.8649 13.7653 17.8516 11.6689L13.1107 19.9492L9.93275 22.0306Z",
    fill: "url(#paint14_radial_20020_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93275 22.0306C8.68202 22.905 8.27955 24.6642 9.09547 25.9539C9.93141 27.2752 11.7691 27.6629 13.1005 26.8432L16.6299 24.6703C17.0642 24.4029 17.6334 24.5436 17.8931 24.9826C19.2527 27.2807 21.8251 28.5776 24.4811 28.3042L28.3131 27.9097C29.2055 27.8179 29.8839 27.0661 29.8839 26.1689V19.0386C29.8839 17.907 29.1912 16.89 28.1467 16.4544C25.9197 15.5256 21.8649 13.7653 17.8516 11.6689L13.1107 19.9492L9.93275 22.0306Z",
    fill: "url(#paint15_linear_20020_6365)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93275 22.0306C8.68202 22.905 8.27955 24.6642 9.09547 25.9539C9.93141 27.2752 11.7691 27.6629 13.1005 26.8432L16.6299 24.6703C17.0642 24.4029 17.6334 24.5436 17.8931 24.9826C19.2527 27.2807 21.8251 28.5776 24.4811 28.3042L28.3131 27.9097C29.2055 27.8179 29.8839 27.0661 29.8839 26.1689V19.0386C29.8839 17.907 29.1912 16.89 28.1467 16.4544C25.9197 15.5256 21.8649 13.7653 17.8516 11.6689L13.1107 19.9492L9.93275 22.0306Z",
    fill: "url(#paint16_linear_20020_6365)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93275 22.0306C8.68202 22.905 8.27955 24.6642 9.09547 25.9539C9.93141 27.2752 11.7691 27.6629 13.1005 26.8432L16.6299 24.6703C17.0642 24.4029 17.6334 24.5436 17.8931 24.9826C19.2527 27.2807 21.8251 28.5776 24.4811 28.3042L28.3131 27.9097C29.2055 27.8179 29.8839 27.0661 29.8839 26.1689V19.0386C29.8839 17.907 29.1912 16.89 28.1467 16.4544C25.9197 15.5256 21.8649 13.7653 17.8516 11.6689L13.1107 19.9492L9.93275 22.0306Z",
    fill: "url(#paint17_linear_20020_6365)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9251 13.2871L13.1181 19.9362L14.8755 18.8326C15.9169 18.1785 17.155 17.9109 18.3736 18.0763L20.8054 18.4064L16.9251 13.2871Z",
    fill: "url(#paint18_radial_20020_6365)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.99486L17.0727 4.1261L20.8962 6.35088L19.8254 8.22068L16 5.99486Z",
    fill: "url(#paint19_linear_20020_6365)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.99486L17.0727 4.1261L20.8962 6.35088L19.8254 8.22068L16 5.99486Z",
    fill: "url(#paint20_linear_20020_6365)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3864 28.1819C8.34099 28.2388 8.2835 28.2854 8.2177 28.318L5.04186 29.8929C4.88048 29.973 4.74443 29.8935 4.73565 29.7136L4.50957 26.172C4.50676 26.1147 4.51384 26.0576 4.53026 26.0032L8.3864 28.1819Z",
    fill: "url(#paint21_linear_20020_6365)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3864 28.1819C8.34099 28.2388 8.2835 28.2854 8.2177 28.318L5.04186 29.8929C4.88048 29.973 4.74443 29.8935 4.73565 29.7136L4.50957 26.172C4.50676 26.1147 4.51384 26.0576 4.53026 26.0032L8.3864 28.1819Z",
    fill: "url(#paint22_linear_20020_6365)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3864 28.1819C8.34099 28.2388 8.2835 28.2854 8.2177 28.318L5.04186 29.8929C4.88048 29.973 4.74443 29.8935 4.73565 29.7136L4.50957 26.172C4.50676 26.1147 4.51384 26.0576 4.53026 26.0032L8.3864 28.1819Z",
    fill: "url(#paint23_linear_20020_6365)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85901 29.4877L5.04187 29.8929C4.88049 29.973 4.74445 29.8935 4.73566 29.7136L4.67773 28.8066L5.85901 29.4877Z",
    fill: "url(#paint24_linear_20020_6365)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_20020_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8178 20.6204L12.1863 23.662C11.823 23.8582 11.7123 24.3276 11.9499 24.6654C12.1518 24.9526 12.5372 25.0423 12.8452 24.8737L17.9079 22.1023C18.4059 21.8297 18.9963 21.7816 19.5319 21.97L28.6287 25.1697V20.26H19.2435C18.7457 20.26 18.2558 20.3839 17.8178 20.6204Z",
    fill: "url(#paint25_linear_20020_6365)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1181 19.9363L14.8755 18.8327C15.9169 18.1786 17.155 17.911 18.3736 18.0764L19.8418 18.2757L17.9031 24.9994L17.8931 24.9827C17.6334 24.5437 17.0642 24.403 16.6299 24.6704L13.1005 26.8433C11.7691 27.663 9.93141 27.2753 9.09547 25.9539C8.27955 24.6643 8.68202 22.9051 9.93275 22.0307L13.1107 19.9492L13.1181 19.9363Z",
    fill: "url(#paint26_linear_20020_6365)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1181 19.9363L14.8755 18.8327C15.9169 18.1786 17.155 17.911 18.3736 18.0764L19.8418 18.2757L17.9031 24.9994L17.8931 24.9827C17.6334 24.5437 17.0642 24.403 16.6299 24.6704L13.1005 26.8433C11.7691 27.663 9.93141 27.2753 9.09547 25.9539C8.27955 24.6643 8.68202 22.9051 9.93275 22.0307L13.1107 19.9492L13.1181 19.9363Z",
    fill: "url(#paint27_radial_20020_6365)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1181 19.9363L14.8755 18.8327C15.9169 18.1786 17.155 17.911 18.3736 18.0764L19.8418 18.2757L17.9031 24.9994L17.8931 24.9827C17.6334 24.5437 17.0642 24.403 16.6299 24.6704L13.1005 26.8433C11.7691 27.663 9.93141 27.2753 9.09547 25.9539C8.27955 24.6643 8.68202 22.9051 9.93275 22.0307L13.1107 19.9492L13.1181 19.9363Z",
    fill: "url(#paint28_radial_20020_6365)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_20020_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7189 2.50317L21.5673 4.24002",
    stroke: "url(#paint29_linear_20020_6365)",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_20020_6365",
    x: 1.78008,
    y: 7.89905,
    width: 15.1894,
    height: 15.5071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.431373 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_20020_6365"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_20020_6365",
    x: 6.68985,
    y: 6.88171,
    width: 12.0514,
    height: 18.9374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_20020_6365"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_20020_6365",
    x: 8.67059,
    y: 11.4189,
    width: 21.2133,
    height: 16.9214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737255 0 0 0 0 0.498039 0 0 0 0 0.611765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_20020_6365"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_20020_6365",
    x: 9.82425,
    y: 18.26,
    width: 20.8045,
    height: 8.90967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_20020_6365"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_20020_6365",
    x: 18.3439,
    y: 2.12817,
    width: 3.59845,
    height: 2.48682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_20020_6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20020_6365",
    x1: 12.2291,
    y1: 9.85296,
    x2: 5.29986,
    y2: 21.7625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9F93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4377 10.0262) rotate(151.144) scale(2.4229 2.39271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89F83",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20020_6365",
    x1: 3.70224,
    y1: 16.7428,
    x2: 4.55547,
    y2: 17.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9B499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20020_6365",
    x1: 16.5293,
    y1: 24.2882,
    x2: 23.0937,
    y2: 30.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B27A98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20020_6365",
    x1: 30.0639,
    y1: 29.9849,
    x2: 28.9922,
    y2: 29.9849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CCB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CCB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5019 26.2916) rotate(-25.5703) scale(1.22777 2.87075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF6C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF6C6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0256 25.9545) rotate(121.322) scale(4.59189 5.53282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B47079"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3489 25.5496) rotate(90) scale(4.4973 3.95465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.775862,
    stopColor: "#B97B96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_20020_6365",
    x1: 9.33328,
    y1: 27.2625,
    x2: 11.13,
    y2: 27.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A996",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.77862 21.4953) rotate(-60.8246) scale(18.5343 7.81888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA7838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14E4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4418 21.7453) rotate(-57.9221) scale(5.23706 3.61201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B94D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B94D0B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_20020_6365",
    x1: 10.0965,
    y1: 22.6306,
    x2: 18.2244,
    y2: 8.38184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98D53",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_20020_6365",
    x1: 17.949,
    y1: 13.4738,
    x2: 28.3893,
    y2: 23.9832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C1B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7763 30.3544) rotate(-135.161) scale(9.85968 6.28011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212492,
    stopColor: "#C88A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C88A97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8251 18.2568) rotate(149.931) scale(5.17395 1.57367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_20020_6365",
    x1: 24.375,
    y1: 13.8437,
    x2: 23.375,
    y2: 15.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD3B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_20020_6365",
    x1: 23.8138,
    y1: 14.125,
    x2: 22.0013,
    y2: 17.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D5BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D5BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_20020_6365",
    x1: 30.3763,
    y1: 21.1875,
    x2: 27.8138,
    y2: 21.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D5BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D5BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1723 20.3441) rotate(-46.1701) scale(7.06149 8.34366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.116714,
    stopColor: "#D78F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576302,
    stopColor: "#D67965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D67965",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_20020_6365",
    x1: 15.5385,
    y1: 4.48738,
    x2: 19.5249,
    y2: 6.50145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E999F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CCEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_20020_6365",
    x1: 20.8962,
    y1: 7.45316,
    x2: 19.9688,
    y2: 6.87503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C979A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4C5DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C979A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_20020_6365",
    x1: 4.93878,
    y1: 27.9636,
    x2: 6.21455,
    y2: 28.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_20020_6365",
    x1: 7.68968,
    y1: 29.5088,
    x2: 6.25722,
    y2: 28.6816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E086A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E086A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_20020_6365",
    x1: 6.53125,
    y1: 27.0313,
    x2: 6.35305,
    y2: 27.3197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB947F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB947F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_20020_6365",
    x1: 4.94186,
    y1: 29.4239,
    x2: 5.4399,
    y2: 29.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B1A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A1870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F0C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_20020_6365",
    x1: 14.855,
    y1: 22.7149,
    x2: 31.23,
    y2: 23.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_20020_6365",
    x1: 10.5638,
    y1: 19.7813,
    x2: 13.345,
    y2: 22.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19D7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.67059 25.9688) rotate(-34.4393) scale(4.53113 5.89016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF8288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8288",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_20020_6365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0312 28.0313) rotate(-47.2026) scale(2.2998 2.85939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B97C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97C93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_20020_6365",
    x1: 21.4284,
    y1: 4.07791,
    x2: 18.7189,
    y2: 2.59581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF756D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338657,
    stopColor: "#FF756D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF756D",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.7ede17af9c89b0100e693b99b2ac866f.svg";
export { ForwardRef as ReactComponent };